export default class UploadResponse {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.fileName = data.fileName || undefined;
        this.fileUrl = data.fileUrl || undefined;
    }
}